import { FC } from 'react'
import Radio, { RadioGroupProps } from 'antd/lib/radio'
import PerIcon from '../Icon'
import RadioGroup from 'antd/lib/radio/group'
import './index.less'
import PerText from '../Text'
export type RatingRadioGroupProps = RadioGroupProps & { maxRating: number }

const PerRatingRadioGroup: FC<RatingRadioGroupProps> = ({ maxRating, value, name, onChange, ...props }) => {
  const ratings: number[] = []
  const minRating = 1
  for (let i = minRating; i <= maxRating; i++) {
    ratings.push(i)
  }
  return (
    <div className="per-rating-radio-group">
      <div className="per-rating-radio-group__icon">
        <PerIcon name="smileySad_fill" size={20} color="secondary-lighter" />
      </div>

      <RadioGroup {...props}>
        {ratings.map((r, index) => (
          <Radio key={index} value={r} data-e2e-radio-btn={index} onChange={onChange} checked={value && value === index + 1}>
            {(r === minRating || r === maxRating || r === value) && (
              <PerText fontSize="xs" color={r === value ? 'primary' : 'secondary'} mt={'xxxs'}>
                {r}
              </PerText>
            )}
          </Radio>
        ))}
      </RadioGroup>

      <div className="per-rating-radio-group__icon">
        <PerIcon name="smileyHappy_fill" size={20} color="secondary-lighter" />
      </div>
    </div>
  )
}

export default PerRatingRadioGroup
